import { BasketProvider } from "../../Services/BasketProvider";
import { SuccessBox, ErrorBox } from "../../Pages/Product/InfoBox";
import { Center } from "../Utils/Center";
import { Loader } from "../Utils/Loader";
import { PrimaryButton } from "./PrimaryButton";


export class BasketSendingBox extends Center
{
    constructor(private _basket: BasketProvider)
    {
        super();
    }

    async OnAppend(): Promise<void>
    {
        await this.TrySend();
    }

    public async TrySend(): Promise<void>
    {
        this.Clear();

        this.Append(
            new Loader("Wysyłanie zamówienia... Proszę czekać")
        );

        try
        {
            const orderUrl = await this._basket.Send();

            this.Clear().Append(
                new SuccessBox("Zgłoszenie zostało wysłane", "Kliknij przycisk poniżej aby śledzić swoje zamówienie"),
                new PrimaryButton("Śledź swoje zamówienie", () => window.open(orderUrl, '_blank')?.focus())
            );
        }
        catch (error: any)
        {
            console.error(error);
            this.Clear().Append(
                new ErrorBox("Nie udało się wysłać zgłoszenia", "Spróbuj ponownie za chwilę"),
                new PrimaryButton("Spróbuj ponownie", () => this.TrySend())
            );
        }
    }
}
